import { createSelector } from 'reselect'

import { selectCockpitFilterManager } from './selectCockpitFilterManager'
import { selectCockpitManagerUsers } from './selectCockpitManagerUsers'

const EMPTY_USERS: never[] = []

export const selectCockpitManagerUsersForFiltering = createSelector(
  [selectCockpitFilterManager, selectCockpitManagerUsers],
  (selectedManager, users) => (selectedManager.length ? users : EMPTY_USERS)
)
